// extracted by mini-css-extract-plugin
export default {"wrapper":"LD-z","button":"MD-z","alternate":"ND-z","disabled":"OD-z","paymentWarning":"PD-z","fadeIn":"QD-z"};